import React, { useState } from "react";
import AddPostIcon from "@mui/icons-material/PostAdd";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AddUpdate from "./AddUpdate";

const AddPost = () => {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [title, setTitle] = useState("Add Post");

  const handleDialogOpen = () => {
    // console.log("Dialog opened");
    setOpen(true);
  };

  const handleDialogClose = () => {
    setCurrentIndex(0);
    setOpen(false);
  };

  const handleAddUpdate = () => {
    // console.log("Add Update");
    setCurrentIndex(1);
    setTitle("Add Update");
    // handleDialogClose();
  };

  const handleAddEvent = () => {
    // console.log("Add Event");
    setTitle("Add Event");
    setCurrentIndex(3);
    // console.log(currentIndex);
    // handleDialogClose();
  };

  const handleAddOffer = () => {
    setTitle("Add Offer");
    setCurrentIndex(2);
    // handleDialogClose();
  };

  return (
    <div>
      <AddPostIcon onClick={handleDialogOpen} className="cursor-pointer" />

      {/* Dialog overlay */}
      {open && (
        <div
          className="fixed inset-0 z-[1200] flex items-center justify-center bg-black bg-opacity-50 "
          role="dialog"
          aria-modal="true"
        >
          <div className={`relative  p-8 text-black bg-white rounded-lg shadow-lg min-w-96 ${currentIndex === 0 ? "w-5/12" : "w-7/12"} transition-all duration-500`}>
            <div className="flex flex-row items-center ">
              {currentIndex > 0 && (
                <ArrowBackIosIcon
                  onClick={() => {
                    setCurrentIndex(0);
                  }}
                  className="cursor-pointer"
                />
              )}
              <p
                className={`${
                  currentIndex === 0 ? "ml-4" : ""
                } text-lg font-semibold text-center`}
              >
                {title}
              </p>
            </div>

            {currentIndex === 0 && (
              <>
                {" "}
                <div
                  onClick={() => {
                    handleAddUpdate();
                  }}
                  className="flex flex-row items-center justify-between p-4 hover:bg-gray-100 hover:cursor-pointer"
                >
                  <div className="flex flex-col ">
                    <p className="">Add update</p>
                    <span className="text-sm text-[#647380]">
                      Post updates to your customer on Google
                    </span>
                  </div>
                  <ArrowForwardIosIcon className="" />
                </div>
                <div className="w-full border-b-[1px] border-gray-800 my-1 " />
                <div
                  onClick={() => {
                    handleAddOffer();
                  }}
                  className="flex flex-row items-center justify-between p-4 hover:bg-gray-100 hover:cursor-pointer"
                >
                  <div className="flex flex-col ">
                    <p className="">Add Offer</p>
                    <span className="text-sm text-[#647380]">
                      Create an offer and attract customers to your business
                    </span>
                  </div>
                  <ArrowForwardIosIcon className="" />
                </div>
                <div className="w-full border-b-[1px] border-gray-800 my-1" />
                <div
                  onClick={() => {
                    handleAddEvent();
                  }}
                  className="flex flex-row items-center justify-between p-4 hover:bg-gray-100 hover:cursor-pointer"
                >
                  <div className="flex flex-col ">
                    <p className="">Add event</p>
                    <span className="text-sm text-[#647380]">
                      Let customers know about events that you are hosting
                    </span>
                  </div>
                  <ArrowForwardIosIcon className="" />
                </div>{" "}
              </>
            )}
            {currentIndex === 1 && (
              <div className="min-h-[250px] max-h-fit overflow-auto  max-w-full">
                <AddUpdate topicType="STANDARD" setModalOpen={(value)=>{
                    setOpen(value)
                    setCurrentIndex(0)
                }} />
              </div>
            )}

            {currentIndex === 2 && (
              <div className="min-h-[250px] max-h-fit overflow-auto  max-w-full">
                <AddUpdate topicType="OFFER" setModalOpen={(value)=>{
                    setOpen(value)
                    setCurrentIndex(0)
                }} />
              </div>
            )}

            {currentIndex === 3 && (
              <div className="min-h-[250px] max-h-fit overflow-auto  max-w-full">
                <AddUpdate topicType="EVENT" setModalOpen={(value)=>{
                    setOpen(value)
                    setCurrentIndex(0)
                }}/>
              </div>
            )}

            <button
              onClick={handleDialogClose}
              className="absolute text-gray-600 top-2 right-2 hover:text-black"
            >
              <CloseIcon />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddPost;
